export const getCheckedColumns = columns => columns.filter(
    column => column.checked,
);

export const getColumnsValue = columns => columns.map(column => column.value);

export const checkColumn = (columns, selectedColumn) => columns.map(column => (
    { ...column, checked: column.value === selectedColumn.value ? !column.checked : column.checked }
));

export const formatAndCheckColumnsByCheckedMetric = (columns, selectedColumns) => {
    const orderMetricsByChecked = columns.map(column => (
        { ...column, checked: selectedColumns.includes(column.value) }));

    if (selectedColumns.length <= 0) {
        return orderMetricsByChecked;
    }

    return orderMetricsByChecked
        .sort((a, b) => {
            if (a.checked === b.checked) {
                return 0;
            } if (a.checked) {
                return -1;
            }
            return 1;
        })
        .map((element, index) => ({
            ...element,
            index,
        }));
};

export const sortColumnsByIndex = columns => columns.sort(
    (metricA, metricB) => metricA.index - metricB.index,
);

export const setColumnsIndexes = columns => columns.map((column, index) => ({ ...column, index }));
